var _defs, _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStoreImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "store-img_svg__Layer_1",
  width: "1em",
  height: "1em",
  viewBox: "0 0 43.94 39.48"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".store-img_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 29.3,
  height: 29.3,
  x: 3.27,
  y: 7.27,
  className: "store-img_svg__st0",
  rx: 4,
  ry: 4
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.97,
  cy: 15.97,
  r: 3.1,
  className: "store-img_svg__st0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m31.67 25.87-8.2-8.2-17.9 18",
  className: "store-img_svg__st0"
})));
export { SvgStoreImg as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDMuOTQiIGhlaWdodD0iMzkuNDgiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQzLjk0IDM5LjQ4Ij4KICA8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjkuMi4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogMi4xLjAgQnVpbGQgMTE2KSAgLS0+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5zdDAgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgICAgc3Ryb2tlOiAjMDAwOwogICAgICAgIHN0cm9rZS1saW5lY2FwOiByb3VuZDsKICAgICAgICBzdHJva2UtbGluZWpvaW46IHJvdW5kOwogICAgICAgIHN0cm9rZS13aWR0aDogM3B4OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0ic3QwIiB4PSIzLjI3IiB5PSI3LjI3IiB3aWR0aD0iMjkuMyIgaGVpZ2h0PSIyOS4zIiByeD0iNCIgcnk9IjQiLz4KICA8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxMS45NyIgY3k9IjE1Ljk3IiByPSIzLjEiLz4KICA8cG9seWxpbmUgY2xhc3M9InN0MCIgcG9pbnRzPSIzMS42NyAyNS44NyAyMy40NyAxNy42NyA1LjU3IDM1LjY3Ii8+Cjwvc3ZnPg==";